import React from 'react'
import PropTypes from 'prop-types'

import CustomLink from '@/shared/components/customLink'
import { getSlugUrl } from '@/shared/utils'

const OverList = ({ data, id, is100 }: any) => {
  return (
    <section id={id} className="border-b border-borderStroke first:border-t py-4 md:py-5">
      <div className={`flex items-center gap-3 md:gap-6`}>
        <div
          className={` flex-shrink-0 w-[82px] md:w-[124px] pr-3 md:pr-6 border-r border-borderStroke py-5 text-center overflow-hidden`}
        >
          <p className={`mb-0 text-sm md:text-base font-bold text-textOffWhite text-uppercase`}>
            {data?.sOver} {is100 ? 'Balls' : 'Over'}
          </p>
          <span className={`pt-2 text-xs md:text-sm font-medium text-textDselected`}>
            {data?.nOverTotal} Runs
          </span>
        </div>
        <div className={`overflow-hidden flex h-full flex-col`}>
          {data?.oOver?.aBowlers[0]?.oBowler?.sFullName &&
            data?.oOver?.aBatters[0]?.oBatter?.sFullName && (
              <div className="h-full mb-2.5 text-ellipsis text-xs md:text-sm font-medium text-textOffWhite">
                <span>
                  {data?.oOver?.aBowlers[0]?.oBowler?.oSeo?.eStatus === 'a' &&
                  data?.oOver?.aBowlers[0]?.oBowler?.eTagStatus === 'a' ? (
                    <CustomLink
                      href={getSlugUrl(`/${data?.oOver?.aBowlers[0]?.oBowler?.oSeo?.sSlug}`)}
                    >
                      {data?.oOver?.aBowlers[0]?.oBowler?.sFullName}
                    </CustomLink>
                  ) : (
                    data?.oOver?.aBowlers[0]?.oBowler?.sFullName
                  )}
                </span>
                <span className="mx-1">To</span>
                <p className="inline">
                  <span>
                    {data?.oOver?.aBatters[0]?.oBatter?.oSeo?.eStatus === 'a' &&
                    data?.oOver?.aBatters[0]?.oBatter?.eTagStatus === 'a' ? (
                      <CustomLink
                        href={getSlugUrl(`/${data?.oOver?.aBatters[0]?.oBatter?.oSeo?.sSlug}`)}
                      >
                        {data?.oOver?.aBatters[0]?.oBatter?.sFullName}
                      </CustomLink>
                    ) : (
                      data?.oOver?.aBatters[0]?.oBatter?.sFullName
                    )}
                  </span>
                  <span>
                    {data?.oOver?.aBatters[1]?.oBatter?.oSeo?.eStatus === 'a' &&
                    data?.oOver?.aBatters[1]?.oBatter?.eTagStatus === 'a' ? (
                      <CustomLink
                        href={getSlugUrl(`/${data?.oOver?.aBatters[1]?.oBatter?.oSeo?.sSlug}`)}
                      >{`, ${data?.oOver?.aBatters[1]?.oBatter?.sFullName}`}</CustomLink>
                    ) : (
                      data?.oOver?.aBatters[1]?.oBatter?.sFullName &&
                      `, ${data?.oOver?.aBatters[1]?.oBatter?.sFullName}`
                    )}
                  </span>
                </p>
              </div>
            )}

          <div className={`flex text-center gap-3 md:gap-6 scroll-list`}>
            {data?.aBall?.map((ball: any, index: number) => {
              return (
                <div className={`m-0`} key={index}>
                  {ball?.sScore === 'w' && (
                    <div
                      className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 bg-WicketBg border-WicketBg text-white text-sm md:text-base`}
                    >
                      {ball?.sScore?.toUpperCase()}
                    </div>
                  )}
                  {ball?.sScore === '4' && (
                    <div
                      className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 border bg-blueScore border-blueScore text-white text-sm md:text-base`}
                    >
                      {ball?.sScore}
                    </div>
                  )}
                  {ball?.sScore === '6' && (
                    <div
                      className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 border bg-blueScore border-blueScore text-white text-sm md:text-base`}
                    >
                      {ball?.sScore}
                    </div>
                  )}
                  {ball?.sScore === '0' && (
                    <div
                      className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 bg-transparent border border-tabBorder text-sm md:text-base`}
                    >
                      {ball?.sScore}
                    </div>
                  )}
                  {(ball?.sScore === '4b' || ball?.sScore === '4lb') && (
                    <div
                      className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 bg-transparent border border-tabBorder text-sm md:text-base`}
                    >
                      {ball?.sScore}
                    </div>
                  )}
                  {ball?.sScore !== 'w' &&
                    ((ball?.nRuns > 0 && ball?.nRuns < 4) ||
                      ball?.nRuns === 5 ||
                      ball?.nRuns > 6) && (
                      <div
                        className={`px-1 min-w-6 md:min-w-7 h-6 md:h-7 flex items-center justify-center rounded-full mb-1.5 bg-transparent border border-tabBorder text-sm md:text-base`}
                      >
                        {ball?.sScore}
                      </div>
                    )}
                  <span className="text-textDselected text-xs md:text-sm font-medium">
                    {ball?.sOver}.{ball?.sBall}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

OverList.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  is100: PropTypes.bool
}

export default OverList
